import { network } from 'services/network';

export const removeCardComment = (id) => {
    const url = `api/bo/removeCardComment?commentId=${id}`;

    return network.get(url).then((response) => {
        return response.data;
    });
};
